module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbae1b24","hasScoped":false}!./src/app/pages/withNavigation/profile/profile.html
// module id = 3115
// module chunks = 1